import React, { useState, useEffect } from 'react';

const Loader = () => {
  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsDark((prev) => !prev);
    }, 800);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center transition-colors duration-700 ${
        isDark ? 'bg-black' : 'bg-white'
      }`}
    >
      <div className="w-64 h-32 flex items-center justify-center">
        <img
          src={
            isDark
              ? 'https://res.cloudinary.com/ditcmszc1/image/upload/v1769763261/imperier-logo-light_bemqas_slewif.png'
              : 'https://res.cloudinary.com/ditcmszc1/image/upload/v1769764197/imperier-logo-dark_eclumx_y2efho.png'
          }
          alt="Imperier Holdings Logo"
          className="w-full h-full object-contain transition-opacity duration-700"
        />
      </div>
    </div>
  );
};

export default Loader;

